import React , {useEffect,useRef} from "react";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import {  useSelector,useDispatch } from 'react-redux';
import { yupResolver } from "@hookform/resolvers/yup";
import PATHS from "../../../routes/paths";
import { loggedIn } from "../../../redux/authSlice";
import { useStudentLoginUserMutation } from "../../../Services/api";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link} from "react-router-dom";

export default function Login() {
   const hasShownToast = useRef(false);
    useEffect(() => {
      if (hasShownToast.current) return;
      hasShownToast.current = true;
  
      const params = new URLSearchParams(window.location.search);
      const payment = params.get('payment');
      
      
      if (payment === 'success') {
        toast.success('Payment successful');
      } else if (payment === 'cancelled') {
        toast.error('Payment cancelled');
      }
    }, []);

  const validationSchema = Yup.object().shape({
    email: Yup.string().required("Email is required").email("Email is invalid"),
    password: Yup.string().required("Password is required").min(3, "Password must be at least 8 characters")
      .required("Password is required"),
  });
  const dispatch = useDispatch();
  const navigator = useNavigate();
  const {userDetail } = useSelector(
    (state) => state.auth
  )
    useEffect(()=>{
      if(userDetail){
        navigator(PATHS.studentDashboard);
      } ///
  },[userDetail,navigator])
  let defaultValues = { email: "", password: "" };
  const notify = () => '';
  const methods = useForm({
    mode: "onTouched",
    resolver: yupResolver(validationSchema),
    defaultValues,
  });
  const [StudentLoginUser,isLoading] = useStudentLoginUserMutation();
  
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = methods;
  const onSubmit = (values) => {
   
    StudentLoginUser({ data: values })
      .unwrap()
      .then((payload) => {
        if (payload.status) {
          if(payload.data===0){
            toast.error(payload.message)
          }
          else{
            const response = {
              token: payload.token,
              user: payload.data,
            };
            localStorage.setItem('authType',2);
            dispatch(loggedIn(response));
            navigator(PATHS.dashboard);
            
          }
          
        } else {
          toast.error(payload.message)
        }
      })
      .catch((error) => {
        toast.error(error.data.message[0].message)
      });
      notify();
    
  };

  return (
    <>
      <main>
        <div className="container">
          <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">

                  <div className="d-flex justify-content-center py-4">

                    <img src="assets/img/logo.png" alt="" />
                  </div>
                  <div className="card mb-3">
                    <div className="card-body">
                      <div className="pt-4 pb-2">
                        <h5 className="card-title text-center pb-0 fs-4">ELEARNING </h5>
                      </div>
                      <form className="row g-3 needs-validation" >
                        <div className="col-12">
                          <label htmlFor="yourUsername" className="form-label">Email Address</label>
                          <div className="input-group has-validation">
                            <input type="email"  {...register("email")} className="form-control" id="yourUsername" />

                          </div>
                          <span className="text-danger">{errors.email?.message}</span>
                        </div>

                        <div className="col-12">
                          <label htmlFor="yourPassword" className="form-label">Password</label>
                          <input type="password" {...register("password")} className="form-control" id="yourPassword" />
                        </div>
                        <span className="text-danger">{errors.password?.message}</span>
                        <div className="col-12">
                            {isLoading.status !='pending' ?                  
                               <button type="submit" className="btn btn-warning w-100" onClick={handleSubmit(onSubmit)}>  CLIENT LOGIN </button>
                            :
                              <button  className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                            }
                          <p> <Link to="/forget-password" className="text-danger">forget password ? </Link></p>
                          <p> Not yet registered? <Link to="/signup" className="text-warning">SIGN UP ? </Link></p>
                        </div>
                        <div className="col-12">
                        </div>
                      </form>

                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
}